import { types } from 'mobx-state-tree';
import { Currency, CurrencyProps } from 'models/reusable-parts/currency';

export interface CashflowSummarySingleItemProps {
  label: string;
  value: CurrencyProps;
}

export const CashflowSummarySingleItem = types.model({
  label: types.string,
  value: Currency,
});

export default {};
